import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { PageContent } from 'src/shared/types/cms';
import { CmsPage } from '../components/cms/cms-page';
import { CoreWebLayout } from '../layouts/Core';
import { ScrollToTop } from '../layouts/Core/shared/scroll';

interface RouteProps {
    coreLayoutComponent?: React.ComponentType<any>;
    cmsContent?: PageContent;
}

export const buildRoutes = ({
    coreLayoutComponent: CoreLayout = CoreWebLayout,
    cmsContent,
}: RouteProps) => {
    return (
        <CoreLayout>
            <ScrollToTop>
                <Switch>
                    <Route path="/">
                        <CmsPage cmsContent={cmsContent} />
                    </Route>
                </Switch>
            </ScrollToTop>
        </CoreLayout>
    );
};

export { Route };
